import { CaretLeftOutlined } from '@ant-design/icons';
import React, { FC } from 'react';
import Wrap from './styles';

type Props = {
  backToPrev: () => void;
};

const backToStepPrev: FC<Props> = ({ backToPrev }) => {
  return (
    <Wrap>
      <div onClick={backToPrev} className="box">
        <CaretLeftOutlined className="icon" />
        <p className="standardFont mb-0 text">リース契約一覧に戻る</p>
      </div>
    </Wrap>
  );
};

export default backToStepPrev;
